import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux'; // for authState if needed
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const BoloGrahakNearby = () => {
  const navigate = useNavigate();
  
  const [allDeals, setAllDeals] = useState([]);
  const [nearbyDeals, setNearbyDeals] = useState({});
  const [locationFetched, setLocationFetched] = useState(false);

  // // Fetch all deals on mount
  // useEffect(() => {
  //   const fetchDeals = async () => {
  //     const res = await axios.get("/api/deals"); // replace with your endpoint
  //     setAllDeals(res.data || []);
  //   };
  //   fetchDeals();
  // }, []);

  useEffect(() => {
    const fallbackDeals = [
      {
        _id: '1',
        title: 'Marine Drive Romance',
        brief: 'Cozy stay at Queen’s Necklace view',
        latitude: 19.0759,
        longitude: 72.8772, // ~0.1 km
        image: '1'
      },
      {
        _id: '2',
        title: 'Gateway Heritage Hotel',
        brief: 'Vintage stay near Gateway of India',
        latitude: 18.9218,
        longitude: 72.8347, // ~5.1 km
        image: '2'
      },
      {
        _id: '3',
        title: 'Juhu Beachside Resort',
        brief: 'Beach resort with sunset view',
        latitude: 19.0988,
        longitude: 72.8260, // ~6.2 km
        image: '3'
      },
      {
        _id: '4',
        title: 'Andheri Smart Stay',
        brief: 'Budget stay for travelers',
        latitude: 19.1197,
        longitude: 72.8468, // ~7.2 km
        image: '4'
      },
      {
        _id: '5',
        title: 'Bandra Luxury Retreat',
        brief: 'Modern comfort in Bandra',
        latitude: 19.0550,
        longitude: 72.8296, // ~5.8 km
        image: '5'
      },
      {
        _id: '6',
        title: 'Powai Lakeside Resort',
        brief: 'Beautiful lake views and peace',
        latitude: 19.1237,
        longitude: 72.9168, // ~6.5 km
        image: '6'
      },
      {
        _id: '7',
        title: 'Thane Nature Lodge',
        brief: 'Escape into the greens',
        latitude: 19.2183,
        longitude: 72.9781, // ~15.2 km
        image: '7'
      },
      {
        _id: '8',
        title: 'Vasai Fort Retreat',
        brief: 'Stay in the historic Vasai Fort',
        latitude: 19.3919,
        longitude: 72.8397, // ~35.5 km
        image: '8'
      },
      {
        _id: '9',
        title: 'Navi Mumbai Serenity',
        brief: 'Urban escape in Navi Mumbai',
        latitude: 19.0330,
        longitude: 73.0297, // ~17.2 km
        image: '9'
      },
      {
        _id: '10',
        title: 'Lonavala Hill Getaway',
        brief: 'Weekend break in hills',
        latitude: 18.7500,
        longitude: 73.4070, // ~84.0 km
        image: '10'
      }
    ];
  
    const fetchDeals = async () => {
      try {
        const res = await axios.get("/api/deals");
        if (res.data && res.data.length > 0) {
          setAllDeals(res.data);
        } else {
          setAllDeals(fallbackDeals);
        }
      } catch (err) {
        setAllDeals(fallbackDeals); // fallback if API fails
      }
    };
  
    fetchDeals();
  }, []);

  const getDistanceInKm = (lat1, lon1, lat2, lon2) => {
    const R = 6371;
    const dLat = (lat2 - lat1) * Math.PI / 180;
    const dLon = (lon2 - lon1) * Math.PI / 180;
    const a = 
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
      Math.sin(dLon / 2) * Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
  };

  const handleNearbyDeals = () => {
    if (!navigator.geolocation) {
      alert("Geolocation not supported by your browser");
      return;
    }

    navigator.geolocation.getCurrentPosition((position) => {
      const userLat = position.coords.latitude;
      const userLon = position.coords.longitude;

      const ranges = {
        'Within 2 Km': [],
        'Within 5 Km': [],
        'Within 10 Km': [],
        'Within 25 Km': [],
        'More than 25 Km': []
      };

      allDeals.forEach(deal => {
        if (deal.latitude && deal.longitude) {
          const distance = getDistanceInKm(userLat, userLon, deal.latitude, deal.longitude);
          if (distance <= 2) ranges['Within 2 Km'].push({ ...deal, distance });
          else if (distance <= 5) ranges['Within 5 Km'].push({ ...deal, distance });
          else if (distance <= 10) ranges['Within 10 Km'].push({ ...deal, distance });
          else if (distance <= 25) ranges['Within 25 Km'].push({ ...deal, distance });
          else ranges['More than 25 Km'].push({ ...deal, distance });
        }
      });

      setNearbyDeals(ranges);
      setLocationFetched(true);
    }, (err) => {
      alert("Location access denied or failed");
    });
  };

  return (
    <div className="p-6">
      <h2 className="text-2xl font-bold mb-4 border-spacing-2 border-t-2 border-white">Deal's Nearby Me</h2>

      <div className="mb-6">
        <button
          onClick={handleNearbyDeals}
          className="px-4 py-2 bg-pink-600 text-white rounded-full hover:bg-pink-700"
        >
          Refresh Nearby Deals
        </button>
      </div>

      {locationFetched && Object.keys(nearbyDeals).map(range => (
        nearbyDeals[range].length > 0 && (
          <div key={range} className="mb-8">
            <h3 className="text-xl font-semibold mb-3 text-yellow-200">{range}</h3>
            {/* <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6"> */}
            <div className="flex flex-col">
              {nearbyDeals[range].map(deal => (
                <div key={deal._id} className="bg-white shadow-md p-4 rounded-xl mb-2">
                  <img 
                    src={`/api/downloads/thinktravel/deals/${deal.image || '1'}.png`}
                    alt={deal.title}
                    className="w-full h-40 object-cover rounded"
                  />
                  <h4 className="mt-2 text-lg font-semibold">{deal.title}</h4>
                  <p className="text-sm text-gray-600">{deal.brief}</p>
                  <p className="text-sm mt-1 text-gray-500">~{deal.distance.toFixed(1)} km away</p>
                  <button 
                    onClick={() => navigate(`/deal/${deal._id}`)}
                    className="mt-3 px-4 py-2 bg-pink-500 text-white rounded-full text-sm"
                  >
                    View Details
                  </button>
                </div>
              ))}
            </div>
          </div>
        )
      ))}
    </div>
  );
};

export default BoloGrahakNearby;
